const BillingAndPlansIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='16'
		viewBox='0 0 20 16'
		width='20'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M19.5999 2.5998V13.3998C19.5999 13.8831 19.4237 14.304 19.0712 14.6623C18.7187 15.0206 18.2949 15.1998 17.7999 15.1998H2.1999C1.71657 15.1998 1.29574 15.0206 0.937402 14.6623C0.579069 14.304 0.399902 13.8831 0.399902 13.3998V2.5998C0.399902 2.11647 0.579069 1.69564 0.937402 1.3373C1.29574 0.978971 1.71657 0.799805 2.1999 0.799805H17.7999C18.2949 0.799805 18.7187 0.978971 19.0712 1.3373C19.4237 1.69564 19.5999 2.11647 19.5999 2.5998ZM2.1999 4.3998H17.7999V2.5998H2.1999V4.3998ZM2.1999 7.9998V13.3998H17.7999V7.9998H2.1999Z'
			fill='currentColor'
		/>
	</svg>
)

export { BillingAndPlansIcon }
